import React from 'react';

const Canada = () => {
  return (
    <div>
      
    </div>
  );
}

export default Canada;
